import { t } from "@/context/language";
import {
  animate,
  motion,
  useInView,
  useMotionValue,
  useTransform,
} from "framer-motion";
import { useEffect, useRef } from "react";
import { PressHighlightPill } from "./pressHighlightPill";

const MERRIWEATHER = { fontFamily: "var(--font-merriweather)" } as const;

export function RecoveredHighlight() {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, { once: true, margin: "-120px" });

  const count = useMotionValue(0);
  const formatted = useTransform(count, latest =>
    latest.toFixed(1).replace(".", ",")
  );

  useEffect(() => {
    if (!inView) return;
    // Começa devagar e acelera até o 39,4 (ease-in).
    const controls = animate(count, 39.4, { duration: 2.2, ease: "easeIn" });
    return () => controls.stop();
  }, [inView, count]);

  return (
    <div
      ref={ref}
      className="flex flex-col items-center py-12 text-center lg:py-20"
    >
      <h2
        className="flex flex-col items-center"
        style={MERRIWEATHER}
      >
        <span className="sr-only">{t.recovered.srLabel}</span>

        <motion.span
          aria-hidden="true"
          className="text-primary text-[5rem] leading-none font-bold sm:text-[8rem] lg:text-[11rem]"
        >
          {formatted}
        </motion.span>

        <span
          aria-hidden="true"
          style={MERRIWEATHER}
          className="mt-2 text-3xl leading-tight font-bold text-black sm:text-4xl lg:text-5xl"
        >
          {t.recovered.line1}
          <br />
          {t.recovered.line2}
        </span>
      </h2>

      <img
        src="/landing-page/logo-icon-fidexa.svg"
        alt=""
        width={44}
        height={44}
        className="mt-8"
      />

      <div className="mt-6">
        <PressHighlightPill />
      </div>
    </div>
  );
}
